import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { defineComponent, ref, getCurrentInstance, watch } from "@vue/composition-api";
import { RadioSection } from "@Shared/components/sections";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import SelectFilter from "./application-status-select-filter.vue";
import { FILOGIX_STATUSES } from "@Shared/@Utils/constants";
export default defineComponent({
  name: "FilterByApplicationStatus",
  components: {
    RadioSection,
    MaterialInput,
    SelectFilter
  },
  setup(props, {
    emit
  }) {
    const internalInstance = getCurrentInstance();
    const selectedType = ref("");
    watch(selectedType, () => {
      emit("select", selectedType.value);
    });
    const typeOptions = [{
      label: internalInstance == null ? void 0 : internalInstance.proxy.$t("application.actions.import.applicationStatus.label"),
      description: internalInstance == null ? void 0 : internalInstance.proxy.$t("application.actions.import.applicationStatus.description"),
      value: "application-status"
    }];
    const statuses = FILOGIX_STATUSES;
    let selectedStatuses = [];
    const handleStatusSelect = data => {
      const statusCode = statuses[data.id];
      if (data.selected) {
        selectedStatuses.push(statusCode);
      } else {
        selectedStatuses = _filterInstanceProperty(selectedStatuses).call(selectedStatuses, code => code !== statusCode);
      }
      emit("change", selectedStatuses);
    };
    return {
      selectedType,
      typeOptions,
      statuses,
      handleStatusSelect
    };
  }
});